import { Box, CircularProgress } from '@mui/material'
import React from 'react'

import GoTripLogo from '../components/project/images/GoTripLogo'

const OnboardingPage = () => {
  return (
    <Box height='100vh' width='100vw' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
      <img src={GoTripLogo} />
      <Box marginTop={6} />
      <CircularProgress size={64} />
    </Box>
  )
}

export default OnboardingPage
